import { lazy } from 'react';
import { authRoles } from 'app/auth';

const DataAppConfig = {
	settings: {
		layout: {}
	},
	auth: authRoles.productModerator,
	routes: [
		{
			path: '/apps/order-product',
			component: lazy(() => import('./list/Datas'))
		}
	]
};

export default DataAppConfig;
